import { useEffect, useState } from 'react';

import { SmartApplyApiError, authVerifyEmail } from '../lib/api-client.js';
import { useAuth } from '../lib/auth-context.js';
import { useRoute } from '../lib/route.js';
import { AuthLayout } from '../components/auth/AuthLayout.js';

type State = 'idle' | 'verifying' | 'ok' | 'error';

export function VerifyEmailRoute() {
  const { refresh } = useAuth();
  const { query, navigate } = useRoute();
  const token = query.token ?? '';

  const [state, setState] = useState<State>('idle');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return;
    let alive = true;
    setState('verifying');
    authVerifyEmail({ token })
      .then(async () => {
        if (!alive) return;
        await refresh();
        setState('ok');
      })
      .catch((err: unknown) => {
        if (!alive) return;
        setState('error');
        setError(err instanceof SmartApplyApiError ? err.message : 'Falha ao verificar.');
      });
    return () => {
      alive = false;
    };
  }, [token, refresh]);

  if (!token) {
    return (
      <AuthLayout title="Token ausente" badge="verificação">
        <p className="font-sans text-base text-[var(--ink-primary)]">
          O link de verificação precisa de um token. Use o link enviado por e-mail.
        </p>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Verificação de e-mail" badge="verificação">
      <div className="card-paper rounded-sm px-7 py-7" style={{ borderLeft: '3px solid var(--accent-forest)' }}>
        {state === 'verifying' && (
          <p className="font-sans text-base text-[var(--ink-primary)]">Verificando...</p>
        )}
        {state === 'ok' && (
          <>
            <p className="font-serif text-lg text-[var(--accent-forest)]">E-mail confirmado.</p>
            <p className="mt-3 font-sans text-sm text-[var(--ink-secondary)]">
              Sua conta está pronta.
            </p>
            <button
              type="button"
              onClick={() => navigate('/')}
              className="mt-6 rounded-sm bg-[var(--ink-primary)] px-5 py-2 font-sans text-sm text-[var(--bg-paper)] hover:opacity-90"
            >
              Continuar
            </button>
          </>
        )}
        {state === 'error' && (
          <>
            <p className="font-serif text-lg text-[var(--accent-crimson)]">Não consegui verificar.</p>
            <p className="mt-3 font-sans text-sm text-[var(--ink-secondary)]">
              {error ?? 'Token inválido ou expirado.'}
            </p>
          </>
        )}
      </div>
    </AuthLayout>
  );
}
